import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

const TableRowSkeleton = ({
  height = 16,
  columnDefs,
}: {
  height?: number
  columnDefs: number[]
}) => (
  <TableRow>
    {columnDefs.map((width, index) => (
      <TableCell key={index}>
        <Skeleton width={width} height={height} />
      </TableCell>
    ))}
  </TableRow>
)

export const SkeletonTable = ({ columnDefs = [80, 60, 60] }: { columnDefs?: number[] }) => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRowSkeleton columnDefs={columnDefs} height={20} />
      </TableHead>
      <TableBody>
        <TableRowSkeleton columnDefs={columnDefs} />
        <TableRowSkeleton columnDefs={columnDefs} />
        <TableRowSkeleton columnDefs={columnDefs} />
        <TableRowSkeleton columnDefs={columnDefs} />
        <TableRowSkeleton columnDefs={columnDefs} />
      </TableBody>
    </Table>
  </TableContainer>
)
